export class CrfVisitrequest {

    "patientId":Number;
    "userId":Number;
    "studyId":Number;
    
}